/**
 * Indique si l'affichage est en mode mobile (< 768px).
 *
 * Le seuil doit rester aligne avec les @media des feuilles de style :
 * CSS n'accepte pas de variable dans une media query, et JS ne lit pas
 * les breakpoints CSS — la valeur est donc volontairement dupliquee ici.
 */

import { useState, useEffect } from "react";

export const MOBILE_QUERY = "(max-width: 768px)";

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    function onChange(e) {
      setIsMobile(e.matches);
    }
    mql.addEventListener("change", onChange);
    // Realigne l'etat si la largeur a change entre le rendu initial et l'effet
    setIsMobile(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
